import React from 'react';
import './Sidebar.css'
import {Button} from "@mui/material";
import newsIcon from '../../assets/images/news.svg'
import eventIcon from '../../assets/images/run.svg'
import messageIcon from '../../assets/images/message.svg'
import arrowLeftIcon from '../../assets/images/arrow_left.svg'
import {Link} from "react-router-dom";

const Sidebar = () => {
    return (
        <div className='sidebar'>
            <ul>
                <li>
                    <Link to="/news">
                        <Button className='w-100'>
                        <span className='icon'>
                            <img src={newsIcon} alt={newsIcon}/>
                        </span>
                            Новости
                            <span className='arrow'>
                            <img className='arr' src={arrowLeftIcon} alt={arrowLeftIcon}/>
                        </span>
                        </Button>
                    </Link>
                </li>
                <li>
                    <Link to="/events">
                        <Button className='w-100'>
                            <span className='icon'>
                                <img src={eventIcon} alt={eventIcon}/>
                            </span>
                            События
                            <span className='arrow'>
                                <img className='arr' src={arrowLeftIcon} alt={arrowLeftIcon}/>
                            </span>
                        </Button>
                    </Link>
                </li>
                <li>
                    <Link to="/reports">
                        <Button className='w-100'>
                            <span className='icon'>
                                <img src={messageIcon} alt={messageIcon}/>
                            </span>
                            Обращения
                            <span className='arrow'>
                                <img className='arr' src={arrowLeftIcon} alt={arrowLeftIcon}/>
                            </span>
                        </Button>
                    </Link>
                </li>
            </ul>
        </div>
    );
};

export default Sidebar;